import { useState } from 'react'
import { C, font } from '../design'
import DevHeader from './DevHeader'
import SkillTree from './SkillTree'

const TABS = [
  { id: 'personal',      label: 'Личностное' },
  { id: 'professional',  label: 'Профессиональное' },
]

export default function Development({ userId, isOwner, isMobile }) {
  const [category, setCategory] = useState('personal')

  return (
    <div style={{ width: '100%', padding: isMobile ? '0 12px 80px' : '0 24px 80px', boxSizing: 'border-box' }}>
      {/* Avatar + Stats header — full width */}
      <DevHeader userId={userId} isOwner={isOwner} isMobile={isMobile} />

      {/* Category subtabs */}
      <div style={{
        display: 'flex', gap: 0,
        borderBottom: `1px solid ${C.border}`,
        marginBottom: 28,
        overflowX: 'auto',
      }}>
        {TABS.map(tab => (
          <button key={tab.id} onClick={() => setCategory(tab.id)} style={{
            background: 'none', border: 'none', cursor: 'pointer',
            padding: isMobile ? '8px 16px' : '10px 24px',
            fontFamily: font.body,
            fontSize: isMobile ? 13 : 14,
            color: category === tab.id ? C.silverHi : C.silverLo,
            borderBottom: `2px solid ${category === tab.id ? C.silver : 'transparent'}`,
            marginBottom: -1,
            transition: 'color 0.15s, border-color 0.15s',
            letterSpacing: '0.02em',
            whiteSpace: 'nowrap',
            flexShrink: 0,
          }}>
            {tab.label}
          </button>
        ))}
      </div>

      {/* Skill tree — full width */}
      <SkillTree
        key={category}
        userId={userId}
        isOwner={isOwner}
        isMobile={isMobile}
        category={category}
      />
    </div>
  )
}
